<template>
  <q-list no-border>
    <q-item
      v-for="(activity, index) in mappedActivities"
      :key="activity.id"
      :to="activity.url || undefined"
    >
      <q-item-side left>
        <user-avatar v-if="user(index)" :user="user(index)"/>
      </q-item-side>
      <q-item-main>
        <div>
          {{ activity.title }}
          <i v-if="activity.tag">
            {{ activity.tag }}
          </i>
        </div>
        <div class="activity-entry__subheadline">
          {{ activity.description }}
        </div>
      </q-item-main>

      <q-item-side right>
        <q-item-tile stamp>{{ activity.timePassed }}</q-item-tile>
      </q-item-side>
    </q-item>
  </q-list>
</template>

<script>
  import UserAvatar from 'components/Common/UserAvatar'
  import { transformActivity } from 'src/utils/activities'

  export default {
    props: {
      activities: {
        required: true,
        type: Array
      }
    },

    methods: {
      user (index) {
        const activity = this.activities[index]

        if (!activity.user) {
          return null
        }

        return activity.user.data
      }
    },

    computed: {
      mappedActivities () {
        return this.activities.map(transformActivity)
      }
    },

    components: {
      UserAvatar
    }
  }
</script>

<style lang="stylus">
@import '~variables'

.activity-entry__subheadline
  color $grey-7
  font-size .875em
</style>
